import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, NgZone, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationPage } from '../../models/application-form.model';
import { DocUploadService } from '../../services/doc-upload.service';
import { LeadFormService } from '../../services/lead-form.service';
import { constants } from '../../utitlity/constant';
import { Helper } from '../../utitlity/helper';
import { CameraComponent } from '../camera/camera.component';
import { InfoModalComponent } from '../popup-modals/info-modal/info-modal.component';

@Component({
  selector: 'app-poa-form',
  template: require('./poa-form.component.html'),
  styles: [require('./poa-form.component.css')]
})
export class PoaFormComponent implements OnInit {

  applicationAEMResponse: any;
  questions: any;
  isLoaded: boolean;
  isFeedbackForm: boolean;
  showThankyou: boolean;
  thankyoupage: any;
  leadFormDetails: any;
  @ViewChild('arnFailedModal') arnFailedModal: InfoModalComponent;
  disableFormField: boolean = false;
  arnNo: string = '';
  validArn: boolean = false;
  @Output() changeEvent: EventEmitter<any> = new EventEmitter<any>();

  infoPopupMessage = {
    message: '',
  }
  constructor(private leadFormService: LeadFormService,
    private router: Router,
    private zone: NgZone, private docUploadService: DocUploadService) {
  }
  ngOnInit() {
    this.initialiseObjects();
  }


  initialiseObjects() {
    sessionStorage.removeItem("countryCode");
    sessionStorage.removeItem('appRef');
    sessionStorage.removeItem('formDetails');
    this.isLoaded = false;
    this.showThankyou = false;
    this.isFeedbackForm = false;
    this.leadFormDetails = new Object();
    Helper.enableSpinner(true);
    this.leadFormService.getPOAFormData()
      .then((response) => {
        this.applicationAEMResponse = JSON.parse(JSON.stringify(response));
        let modifiedAppData = new ApplicationPage(this.applicationAEMResponse);
        this.questions = modifiedAppData.applicationForm.sections;
        Helper.enableSpinner(false);
        this.isLoaded = true;

      }, (err) => {
        Helper.enableSpinner(false);
        this.router.navigate(['error']);
      });
  }
  redirectPageTo(page) {
    Helper.enableSpinner(false);
    this.zone.run(() => {
      this.router.navigate([page]);
    });
  }

  onFieldChange(event) {
    this.changeEvent.emit(event);
  }
  onTypeaheadFieldChange(event) {
  }
  getRows(panel) {
    return Object.keys(panel.panelRows);
  }
  getKeys(pnl) {
    return Object.keys(pnl);
  }


  createLeadFormRequestObject() {
    let panelRows = this.questions[0]["panels"][0]["Panel1"]["panelRows"];
    let panelRowsLength = Object.keys(panelRows).length;

    for (let i = 1; i <= panelRowsLength; i++) {
      for (let item of panelRows['Row' + i]) {
        if (item["backendField"] && item["backendField"] != '' && item["show"]) {
          if (item["backendField"] == 'country') {
            this.leadFormDetails[item["backendField"]] = 'AE';
          }
          else if (item["backendField"] == 'city') {
            this.leadFormDetails[item["backendField"]] = item["value"].code;

          }
          else {
            this.leadFormDetails[item["backendField"]] = item["value"];
          }

        }
      }
    }
    this.leadFormDetails["mobileCountryCode"] = '971';
    this.leadFormDetails['addressId'] = "RA";
  }

  continueClick() {
    Helper.enableSpinner(true);
    sessionStorage.removeItem('appRef');
    sessionStorage.removeItem('formDetails');

    if (!this.arnNo) {
      this.createLeadFormRequestObject();
      let leadFormDetails = JSON.parse(JSON.stringify(this.leadFormDetails));

      let finalLeadFormDetails = { ...leadFormDetails };

      this.docUploadService.validateEmiratesID(finalLeadFormDetails)

        .then(res => {

          this.arnNo = res.applicationReferenceNumber;
          this.validArn = true;
          this.disableFormField = true;
          sessionStorage.setItem('arnNo', this.arnNo);
          sessionStorage.setItem('formDetails', JSON.stringify(finalLeadFormDetails));
          this.router.navigate(['/poa-doc']);
          Helper.enableSpinner(false);


        }
          , err => {
            Helper.enableSpinner(false);
            if (err instanceof HttpErrorResponse) {

              if (err.status === 400) {
                if (err["error"]["status"] === 'STPPOA01') {
                  this.infoPopupMessage.message = constants.POA_ERROR_MSG;
                  this.arnFailedModal.show();
                }
                else if (err["error"]["status"] === 'STPARMX01') {
                  alert("Application is in progress");
                }
                else if (err["error"]["status"] == 'Customer not found') {
                  alert("Customer not found");
                }

              }
              else {
                this.router.navigate(['error']);
              }
            }


          })


    }
    else {
      Helper.enableSpinner(false);
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/poa-form/poa-form.component.ts